import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { Store, Action } from "@ngrx/store";
import { Actions } from "@ngrx/effects";
import { AppState } from "@store/app-state";
import { ModalService } from "@services/modal";
import { Timeslot } from "@models/timeslot";
import { Contact } from "@models/contact";
import { Course } from "@models/course";
import { Booking } from "@models/booking";
import { ContactsStore } from "@store/contacts";
import { BookingsStore } from "@store/bookings";
import { WorkshopsStore } from "@store/workshops";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import {
  CompleterService,
  CompleterData,
  CompleterItem
} from 'ng2-completer'
import {
  CREATE_BOOKING,
  ADD_BOOKING,
  UPDATE_BOOKING,
  REPLACE_BOOKING,
  FETCH_POTENTIAL_BOOKING_STUDENTS,
  POPULATE_POTENTIAL_BOOKING_STUDENTS
} from "@reducers/bookings";
import { BookingPotentialStudentsParams } from "@services/booking";
import { Workshop } from "@models/workshop";

@Component({
  selector: 'booking-form',
  templateUrl: './booking-form.pug',
})
export class BookingFormComponent implements OnInit, OnDestroy {

  @Input() timeslot: Timeslot
  @Input() tutor: Contact
  @Input() period: number
  @Input() public mode: string = "new"

  public bookingsSubscription: Subscription
  public workshopsSubscription: Subscription

  public students: Contact[] = []

  public studentSearchStr: string
  public studentCompleter: CompleterData
  public courseSearchStr: string
  public courseCompleter: CompleterData

  public workshop: Workshop
  public courses: Course[] = []

  public booking: Booking

  constructor(
    private store: Store<AppState>,
    private completerService: CompleterService,
    private actions: Actions,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.workshopsSubscription =
      this.store.select('workshopsReducer').subscribe((s: WorkshopsStore) => {
        this.workshop = s.workshops.find(w => this.timeslot.window.workshopId == w.id)
        this.courses = this.workshop.courses
      })

    this.bookingsSubscription =
      this.store.select('bookingsReducer').subscribe((s: BookingsStore) => {
        this.booking            = s.editableBooking
        this.students           = s.potentialStudents
        this.populateStudentCompleter()
        this.setupCompletersFromState()
      })

    this.populateStudents()
  }

  populateCoursesCompleter() {
    this.courseCompleter =
      this.completerService.local(this.courses, "subjectCode, name", "name")
  }

  populateStudentCompleter() {
    this.studentCompleter =
      this.completerService.local(this.students, "fullName", "fullName")
  }

  populateStudents() {
    const payload: BookingPotentialStudentsParams = {
      date: this.timeslot.date,
      period: this.period,
      windowId: this.timeslot.windowId
    }
    this.store.dispatch({ type: FETCH_POTENTIAL_BOOKING_STUDENTS, payload })
  }

  clickedSave() {
    this.actions
      .ofType(ADD_BOOKING, REPLACE_BOOKING)
      .take(1)
      .subscribe(() => { this.modalService.closeModal() })

    switch (this.mode) {
      case "new": {
        this.store.dispatch({ type: CREATE_BOOKING, payload: this.booking })
        break
      }
      case "edit": {
        this.store.dispatch({ type: UPDATE_BOOKING, payload: this.booking })
        break
      }
    }
  }

  selectedStudent(e: CompleterItem) {
    if (e && e.originalObject) {
      const contact           = e.originalObject as Contact
      this.booking.contact    = contact
      this.booking.contactId  = contact.id
    }
  }

  selectedCourse(e: CompleterItem) {
    if (e && e.originalObject) {
      const course = e.originalObject as Course
      this.booking.course = course
      this.booking.courseId = course.id
    }
    else {
      this.booking.course = null
      this.booking.courseId = null
    }
  }

  setupCompletersFromState() {
    this.populateCoursesCompleter()

    if (this.booking.contact) {
      this.studentSearchStr   = this.booking.contact.fullName
    }

    if (this.booking.course) {
      this.courseSearchStr    = this.booking.course.name
    }
  }

  ngOnDestroy() {
    this.bookingsSubscription.unsubscribe()
    this.workshopsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/booking-form.ts